/* eslint-disable */ 

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  ApiClientBase,
  API_BASE_URL
} from '@mds/angular-core';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SocialLoginClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getUserLogins(throwError?: boolean): Observable<SocialLoginResponse[]> {
      let url = this.baseUrl + '/sociallogin';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<SocialLoginResponse[]>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PasswordClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  hasPassword(throwError?: boolean): Observable<HasPasswordResponse> {
      let url = this.baseUrl + '/password';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<HasPasswordResponse>(url, this.jsonOptions), throwError);
  }

  changePassword(model: ChangePasswordRequest, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/password';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.put<void>(url, model, this.jsonOptions), throwError);
  }

  addPassword(model: AddPasswordRequest, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/password';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  resetPassword(model: ResetPasswordRequest, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/password/reset';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  createPasswordResetLink(model: CreatePasswordResetLinkRequest, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/password/reset-link';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class OrganizationClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getUserOrganizations(throwError?: boolean): Observable<OrganizationResponse[]> {
      let url = this.baseUrl + '/organization';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<OrganizationResponse[]>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class MfaClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  getMfa(throwError?: boolean): Observable<MfaResponse> {
      let url = this.baseUrl + '/mfa';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<MfaResponse>(url, this.jsonOptions), throwError);
  }

  createAuthenticator(throwError?: boolean): Observable<AuthenticatorResponse> {
      let url = this.baseUrl + '/mfa/authenticator';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<AuthenticatorResponse>(url, this.jsonOptions), throwError);
  }

  enableAuthenticator(model: EnableAuthenticatorRequest, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/mfa/authenticator/enable';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.put<void>(url, model, this.jsonOptions), throwError);
  }

  disableAuthenticator(throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/mfa/authenticator/disable';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.put<void>(url, this.jsonOptions), throwError);
  }

  createRecoveryCodes(throwError?: boolean): Observable<RecoveryCodesResponse> {
      let url = this.baseUrl + '/mfa/recovery-codes';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<RecoveryCodesResponse>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class EmailClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  confirmEmail(model: ConfirmEmailRequest, throwError?: boolean): Observable<ConfirmEmailResponse> {
      let url = this.baseUrl + '/email/confirm';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<ConfirmEmailResponse>(url, model, this.jsonOptions), throwError);
  }

  resendEmailConfirmation(model: ResendEmailConfirmationRequest, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/email/resend-confirmation';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  changeEmail(model: ChangeEmailRequest, throwError?: boolean): Observable<ChangeEmailResponse> {
      let url = this.baseUrl + '/email';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.put<ChangeEmailResponse>(url, model, this.jsonOptions), throwError);
  }

  createChangeEmailLink(model: CreateChangeEmailLinkRequest, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/email/change-link';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ConfigClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  config(throwError?: boolean): Observable<ConfigurationModel> {
      let url = this.baseUrl + '/config';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<ConfigurationModel>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AccountClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    super();
  }

  register(request: RegisterAccountRequest, throwError?: boolean): Observable<RegisterAccountResponse> {
      let url = this.baseUrl + '/account';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<RegisterAccountResponse>(url, request, this.jsonOptions), throwError);
  }

  delete(throwError?: boolean): Observable<Unit> {
      let url = this.baseUrl + '/account';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.delete<Unit>(url, this.jsonOptions), throwError);
  }
}

export interface SocialLoginResponse {
    email: string;
    providerName: string;
    providerKey: string;
}

export interface HasPasswordResponse {
    hasPassword: boolean;
}

export interface ChangePasswordRequest {
    currentPassword: string;
    newPassword: string;
}

export interface AddPasswordRequest {
    newPassword: string;
}

export interface ReCaptchaTokenRequest {
    token: string;
}

export interface ResetPasswordRequest extends ReCaptchaTokenRequest {
    id: string;
    code: string;
    newPassword: string;
}

export interface CreatePasswordResetLinkRequest extends ReCaptchaTokenRequest {
    email: string;
}

export interface OrganizationResponse {
    name: string;
    displayName: string;
}

export interface MfaResponse {
    isAuthenticatorEnabled: boolean;
    recoveryCodesCount: number;
}

export interface AuthenticatorResponse {
    issuer: string;
    sharedSecret: string;
    email: string;
}

export interface EnableAuthenticatorRequest {
    verificationCode: string;
}

export interface RecoveryCodesResponse {
    recoveryCodes: string[];
}

export interface ConfirmEmailResponse {
    email: string;
}

export interface ConfirmEmailRequest {
    id: string;
    code: string;
}

export interface ResendEmailConfirmationRequest extends ReCaptchaTokenRequest {
    email: string;
}

export interface ChangeEmailResponse {
    email: string;
}

export interface ChangeEmailRequest {
    code: string;
    email: string;
}

export interface CreateChangeEmailLinkRequest {
    email: string;
}

export interface ConfigurationModel {
    appInsights: ApplicationInsightsModel;
    authConfig: AngularAuthConfigModel;
    reCaptcha: ReCaptchaModel;
    reAuthentication: ReAuthenticationModel;
}

export interface ApplicationInsightsModel {
    connectionString: string;
}

export interface AngularAuthConfigModel {
    redirectUri: string;
    postLogoutRedirectUri: string;
    clientId: string;
    issuer: string;
    responseType: string;
    scope: string;
    resource: string;
    acrValues: string;
}

export interface ReCaptchaModel {
    siteKey: string;
}

export interface ReAuthenticationModel {
    maxAgeInSeconds: number;
}

export interface RegisterAccountResponse {
    id: string;
    email: string;
}

export interface RegisterAccountRequest extends ReCaptchaTokenRequest {
    email: string;
    password: string;
}

/** Represents a void type, since Void is not a valid return type in C#. */
export interface Unit {
}